var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icLogo",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#00ace5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 48.7 23.3 c -4 0 -8.3 -2.6 -10.4 -4.6 c -2.3 -2.1 -8.6 -8.9 -8.6 -9 C 25.5 5.1 20 0 14.4 0 C 7.7 0 1.9 4.6 0.4 10.8 c 0.1 -0.4 2.2 -6 10.2 -6 c 4 0 8.3 2.6 10.4 4.6 c 2.3 2.1 8.6 8.9 8.6 9 c 4.1 4.6 9.7 9.7 15.2 9.7 c 6.7 0 12.5 -4.6 14 -10.8 c -0.1 0.4 -2.2 6 -10.2 6 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-loop-bottom)",
    d: "M 29.6 18.3 c 0 0 -1.8 -2 -3.9 -4.1 c -1.1 1.3 -2.7 3.1 -4.5 4.7 c -3.4 3 -5.6 3.6 -6.9 3.6 c -4.8 0 -8.6 -3.8 -8.6 -8.4 c 0 -4.6 3.9 -8.4 8.6 -8.4 c 0.2 0 0.4 0 0.6 0.1 c -1.4 -0.6 -3 -0.9 -4.4 -0.9 c -8 0 -10.1 5.6 -10.2 6 A 13.5 13.5 0 0 0 0 14 c 0 7.7 6.4 14 14.3 14 c 3.3 0 7 -1.7 10.8 -5 c 1.8 -1.6 3.4 -3.3 4.5 -4.6 a 2.3 2.3 0 0 1 0 -0.1 l 0 0 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#logo-loop-top)",
    d: "M 29.6 9.7 c 0 0 1.8 2 3.9 4.1 c 1.1 -1.3 2.7 -3.1 4.5 -4.7 c 3.4 -3 5.6 -3.6 6.9 -3.6 c 4.8 0 8.6 3.8 8.6 8.4 c 0 4.6 -3.9 8.4 -8.6 8.4 a 3.7 3.7 0 0 1 -0.6 -0.1 c 1.4 0.6 3 0.9 4.4 0.9 c 8 0 10.1 -5.6 10.2 -6 c 0.3 -1 0.4 -2.1 0.4 -3.2 C 59.3 6.3 52.8 0 44.9 0 c -3.3 0 -6.9 1.7 -10.7 5 C 32.3 6.6 30.8 8.3 29.6 9.7 l 0 0.1 h 0 Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-loop-bottom",
    x1: 21.883,
    x2: 2.381,
    y1: 26.169,
    y2: 5.974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#ff0079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#592489"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-loop-top",
    x1: 37.398,
    x2: 56.9,
    y1: 1.844,
    y2: 22.039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#ff4b00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#ffab00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcp);
export default __webpack_public_path__ + "static/media/icp.b23b811317665786a538c50c0c83e1a4.svg";
export { ForwardRef as ReactComponent };